import { jsx as _jsx } from "react/jsx-runtime";
import '../styles/tailwind.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import async from 'async';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import MidnightRefresh from './utils/MidnightRefresh';
import CompanyStore from './stores/CompanyStore/store';
import ClientStateStore from './stores/ClientStateStore/store';
import FeatureFlagStore from './stores/FeatureFlagStore/store';
import API from './utils/WebAPIUtils';
import Mobile from './components/mobile/Mobile';
import * as Analytics from './utils/Analytics';
import initializeLD from './utils/LaunchDarkly';
import { fetchGame, setupRealtimeSubscriptions } from './utils/DataUtils';
import { initPusher } from './services/pusher';
window.React = React; // export for http://fb.me/react-devtools
// Track root instance to prevent multiple createRoot calls (for HMR)
var rootInstance = null;
var renderRoutes = function () {
    // Render app
    var rootElement = document.getElementById('main');
    if (!rootElement) {
        console.error('Root element not found');
        return;
    }
    // Only create root once, reuse on HMR or multiple calls
    if (!rootInstance) {
        rootInstance = createRoot(rootElement);
    }
    rootInstance.render(_jsx(BrowserRouter, { children: _jsx(Routes, { children: _jsx(Route, { path: "/mobile/*", element: _jsx(Mobile, {}) }) }) }));
};
var initData = function (result) {
    var _a;
    CompanyStore.init(result);
    ClientStateStore.init({ loggedIn: true });
    // Initialize Analytics
    var currentUser = CompanyStore.getCurrentUser();
    if (currentUser) {
        Analytics.identify(currentUser);
        Analytics.group(CompanyStore.getCompanyInfo());
        // LaunchDarkly
        initializeLD(result.launch_darkly_client_side_id || ((_a = result.app_settings) === null || _a === void 0 ? void 0 : _a.launch_darkly_client_side_id) || '', {
            key: String(currentUser.id),
            anonymous: false,
            email: currentUser.email,
            custom: {
                accountId: currentUser.account_id
            }
        }, FeatureFlagStore.updateFlags.bind(FeatureFlagStore));
    }
    // Begin data syncing
    async.each(result.games_list.all, fetchGame, function () {
        var _a;
        console.log('DO YOU SEE ME?');
        setupRealtimeSubscriptions(result.sbb_pusher_key || ((_a = result.app_settings) === null || _a === void 0 ? void 0 : _a.sbb_pusher_key) || '');
    });
};
window.initData = initData;
API.fetchApplicationData(function (error, result) {
    if (!error && result) {
        initData(result);
        renderRoutes();
        return;
    }
    API.getAppSettings(function (err, res) {
        if (err) {
            console.log('Error getting app settings: ', err);
            return;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var settings = res;
        if (!settings || !settings.sbb_pusher_key) {
            console.log('No Pusher key found in app settings');
            return;
        }
        initPusher(settings.sbb_pusher_key);
        renderRoutes();
    });
});
// Setup midnight refresh
MidnightRefresh();
